import type { HelpFile } from '../../types/help'
import { IdentityLifecycleTimelineTestIds } from '../../../testids/IdentityLifecycleTimelineTestIds'

export const identityLifecycleTimelineHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [IdentityLifecycleTimelineTestIds.lifecycleTimeline]:
      'Vertical timeline of identity lifecycle events — newest first. Each row shows the state pair, trigger source, actor, timestamp, and reason.',
    [IdentityLifecycleTimelineTestIds.lifecycleFiltersPanel]:
      'Filter the timeline by trigger source and date range. Filters are collapsed by default — click "Filters" to expand.',
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineEmpty]:
      'No lifecycle events match the current filters. Use "Clear filters" to reset, or wait for new transitions to be recorded.',
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineError]:
      'The timeline could not be loaded. Check the error log for details and retry.',
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineLoading]: null,
    [IdentityLifecycleTimelineTestIds.lifecycleTimelineRows]:
      'Identity lifecycle event rows — each row links to the trigger reference (job execution or access request) when present.',
    [IdentityLifecycleTimelineTestIds.lifecycleEventTriggerRefLink]:
      'Deep link to the trigger that caused this state change — opens the related job execution or access request.',
    [IdentityLifecycleTimelineTestIds.btnToggleLifecycleFilters]:
      'Show or hide the filter panel for this timeline.',
    [IdentityLifecycleTimelineTestIds.btnClearLifecycleFilters]:
      'Reset all filters on this timeline.',
    [IdentityLifecycleTimelineTestIds.inputLifecycleFilterFrom]:
      'Lower bound of the date range — events with a changed_at before this value are hidden.',
    [IdentityLifecycleTimelineTestIds.inputLifecycleFilterTo]:
      'Upper bound of the date range — events with a changed_at after this value are hidden.',
  },
}
